module.exports = __webpack_public_path__ + "static/media/reusability.3f9adb0a.svg";